<template>
  <div :style="{width: `${inputWidth}px`}" class="pt-2">
    <div style="display: flex; justify-content: flex-end; padding-right: 5%">
      <Feedback></Feedback>
    </div>
    <div class="d-flex align-center justify-center mt-3">
      <div class='position-relative textareaStyle' :style="{width: `90%`}">
        <v-textarea
          class="gradient-border-textarea"
          filled
          dense
          outlined
          flat
          auto-grow
          background-color='#fff'
          hide-details
          rows='1'
          @keydown.enter='handleEnter'
          v-model='newMessage'
          placeholder='Chat with CSSA'
        >
          <template slot="append">
            <v-btn
              fab
              :loading='sendMessageLoading'
              :disabled='!newMessage'
              color='primary'
              @click='sendMessage'
              small
            >
              <img width="50px" :src="require('@/assets/images/icon-input.png')">
            </v-btn>
          </template>
        </v-textarea>
      </div>
      <v-dialog
        v-model='uploadFileDialog'
        persistent
        width='768px'
      >
        <v-card>
          <v-card-text style='padding: 20px 24px;'>
            <v-icon @click='uploadFileDialog = false' class='cursor-pointer'
                    style='position: absolute; right: 24px' color='#000000' size='22'>
              {{ icons.mdiWindowClose }}
            </v-icon>
            <v-container>
              <div>
                <div>
                  <span style='color: #000000e6; font-size: 24px; font-weight: bold'>上传文件</span>
                </div>
                <div class='mt-2'>
                  <span style='color: #000c; font-size: 16px'>总结并于您的文件对话</span>
                </div>
              </div>
              <v-card
                class='mt-6 text-center'
                height='420'
                style='background: #f7f7f7; border: 1px dashed #0000001a; border-radius: 12px; display: grid; place-items: center'>
                <div>
                  <v-icon size='48'>
                    {{ icons.mdiFileDocumentOutline }}
                  </v-icon>
                  <div style='margin-top: 18px'>
                <span
                  style='color: #000000cc; font-weight: 600; font-size: 14px'>点击或拖放文件到此处上传</span>
                  </div>
                  <div style='color: #000000cc; font-size: 12px; margin-top: 4px;'>
                    支持PDF、DOC、XLSX、TXT等多种格式
                  </div>
                  <div style='color: #000000cc; font-size: 12px; margin-top: 4px;'>
                    最大文件大小：200MB
                  </div>
                  <input style='display: none' ref='uploadFile' type='file' />
                  <v-btn
                    color='#000000'
                    class='white--text'


                    style='margin-top: 24px'
                    rounded
                    @click='$refs.uploadFile.click()'
                  >
                    <v-img class='mr-2' width='16'
                           :src="require('@/assets/images/upload-white.png')"></v-img>
                    <span style='font-size: 13px'>上传文件</span>
                  </v-btn>
                </div>
              </v-card>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import {
  mdiArrowUp,
  mdiArrowUpCircle,
  mdiAttachment,
  mdiCloudUpload,
  mdiFileDocumentOutline,
  mdiMessageText,
  mdiSend,
  mdiThumbUpOutline,
  mdiWindowClose,
} from '@mdi/js'
import Feedback from '@/modules/chat/view/chatbot/mobile/component/feedback'

export default {
  components: {
    Feedback,
  },
  props: {
    sendMessageLoading: {
      type: Boolean,
      default: false,
    },
    inputWidth: {
      type: Number,
      default: 672,
    },
  },
  data() {
    return {
      openDeepSeek: false,
      uploadFileDialog: false,
      newMessage: '',
      icons: {
        mdiArrowUpCircle,
        mdiMessageText,
        mdiSend,
        mdiThumbUpOutline,
        mdiArrowUp,
        mdiAttachment,
        mdiFileDocumentOutline,
        mdiCloudUpload,
        mdiWindowClose,
      },
    }
  },
  methods: {
    handleEnter(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault()
        if (this.newMessage) {
          this.sendMessage()
        }
      }
    },
    sendMessage() {
      // this.sendMessageLoading = true
      if (this.sendMessageLoading) {
        return
      }
      this.$emit('sendMessage', this.newMessage)
      this.newMessage = '' // 清空输入框
    },
    async getMicrophoneAccess(message) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        stream.getTracks().forEach(track => track.stop()) // 立即关闭流，仅获取权限
        this.fetchMicrophoneList() // 获取设备列表
      } catch (error) {
        alert('麦克风权限被拒绝')
      }
    },
    fetchMicrophoneList() {
      navigator.mediaDevices.enumerateDevices().then(devices => {
        this.microphones = devices.filter(
          device => device.kind === 'audioinput' &&
            !['default', 'communications'].includes(device.deviceId),
        )
      })
    },
  },
}
</script>
<style lang='scss' scoped>
/* 移除默认边框 */
.gradient-border-textarea {
  --v-input-border-color: transparent !important;
}

.textareaStyle {
  padding: 1.5px;
  border-radius: 16px;
  background: linear-gradient(294.63deg, #562cdf 0%, #d69cff 100%);
  box-shadow: 0 4px 8px 2px rgba(238, 218, 253, 0.8); /* 下方阴影 */
}

::v-deep .v-input__slot {
  border-radius: 16px !important;
}

/* 禁用状态 */
::v-deep .gradient-border-textarea:disabled .v-input__slot::before {
  opacity: 0.5;
}

::v-deep .v-input__append-inner {
  margin: 4px 0;
}

.no-focus-effect {
  ::v-deep .v-input__control {
    &:focus-within {
      ::v-deep .v-input__slot {
        background-color: transparent !important;
        box-shadow: none !important;
      }
    }
  }
}
</style>
